import angular from 'angular';

import '../controller/controller';

angular.module("core.application.main").factory("core.application.main.factory.error", [
    "$rootScope", "$q",
    function($rootScope, $q) {
        // global error handling
        const expose = {};

        const resetErrorHandler = (responseOrConfig) => {
            $rootScope.fatalError = false
            return $q.resolve(responseOrConfig)
        }

        const errorHandler = (error) => {
            $rootScope.fatalError = false;
            switch (error.status) {
                // Important: don't include 422 in here as the backend uses that
                // when most validation errors occur and those shouldn't be
                // handled in a global way here.
                case 0:
                case 405:
                case 500:
                    $rootScope.fatalError = true;
                    break;
                case 401: // handle session time outs gracefully
                    if (!error.config.url.includes('merchants/auth/verify')) {
                        $rootScope.unauthorisedError = true;
                    }
                    break;
            }
            return $q.reject(error);
        };

        expose.request = resetErrorHandler
        expose.requestError = errorHandler;
        expose.responseError = errorHandler;

        return expose;

    }
]);
